export default __webpack_public_path__ + "static/examp7-e3ee1c5f18caf1065115f9a1c30d8fb3.gif";